// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1WY1Y","savePackageButton":"ClientWallet_savePackageButton__3qLlk"};